import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorPaymentSearch = () => {
  const paymentSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/fund-payment/search', payload, (response) => {
      loading(false)
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
    })
  }, [])
  return { paymentSearch }
}

export default InteractorPaymentSearch
